export default function Help() {
    return (
      <div className="p-6 space-y-6 max-w-3xl">
        <h1 className="text-3xl font-semibold">Help & Support</h1>
  
        <div className="bg-white p-6 rounded-xl shadow border space-y-4">
          <h2 className="text-xl font-semibold">Frequently Asked Questions</h2>
  
          <details className="border p-4 rounded">
            <summary className="font-medium cursor-pointer">How to apply leave?</summary>
            <p className="text-gray-600 mt-2">
              Go to the Leave page → Click “Apply Leave” → Fill the form → Submit.
            </p>
          </details>
  
          <details className="border p-4 rounded">
            <summary className="font-medium cursor-pointer">
              How to check attendance?
            </summary>
            <p className="text-gray-600 mt-2">
              Open Attendance page → Filter by date → View summary.
            </p>
          </details>
  
          <details className="border p-4 rounded">
            <summary className="font-medium cursor-pointer">How to contact support?</summary>
            <p className="text-gray-600 mt-2">
              Use the message page or email us at support@lessspace.com.
            </p>
          </details>
        </div>
  
        <div className="bg-white p-6 rounded-xl shadow border">
          <h2 className="text-xl font-semibold mb-3">Need More Help?</h2>
          <p className="text-gray-600 mb-3">Submit a support ticket below:</p>
  
          <input
            placeholder="Subject"
            className="border p-2 rounded w-full mb-3"
          />
          <textarea
            placeholder="Describe your issue..."
            className="border p-2 rounded w-full h-32"
          ></textarea>
  
          <button className="mt-4 bg-green-600 text-white px-4 py-2 rounded">
            Submit Ticket
          </button>
        </div>
      </div>
    );
  }
  